__turbopack_context__.v({
  "main": "layout-module-scss-module__S9Zxhq__main",
  "wrapper": "layout-module-scss-module__S9Zxhq__wrapper",
});
